import React from "react";
import { Box, Slider } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { PROJECT_COLOR } from "../../constants/colors";

export default function GradeSlider({ levelValue, onChangeLevel }) {
  return (
    <Box sx={{ width: "100%", maxWidth: 520 }}>
      <Slider
        step={25}
        min={0}
        max={100}
        value={levelValue}
        onChange={(event, newValue) => onChangeLevel(newValue)}
        marks={[
          { value: 0, label: "D" },
          { value: 25, label: "C" },
          { value: 50, label: "B" },
          { value: 75, label: "A" },
          { value: 100, label: "S" },
        ]}
        sx={{
          height: "10px",
          "& .MuiSlider-track": { backgroundColor: PROJECT_COLOR, border: "none" },
          "& .MuiSlider-rail": { backgroundColor: "#D9D9D9", opacity: 1 },
          "& .MuiSlider-thumb": { backgroundColor: PROJECT_COLOR },
          "& .MuiSlider-thumb:hover, & .MuiSlider-thumb.Mui-focusVisible": {
            boxShadow: `0 0 0 8px ${alpha(PROJECT_COLOR, 0.18)}`,
          },
          "& .MuiSlider-mark": { display: "none" },
          "& .MuiSlider-markLabel": {
            fontSize: "14px",
            fontWeight: 700,
            marginTop: "10px",
            color: "#D9D9D9",
          },
          "& .MuiSlider-markLabelActive": { color: "#545454" },
          color: "#545454",
        }}
      />
    </Box>
  );
}